import React from 'react';

import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';

import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import PortraitOutlinedIcon from '@material-ui/icons/PortraitOutlined';

import ContentRow from '../../../../../components/ContentRow/ContentRow.js';
import {
  getString,
  stringToDateShortLeadingZero,
} from '../../../../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'personalInformationCard';

class TenancyInformationCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      classes,
      name,
      reference,
      address,
      tenancyStatus,
      tenancyStart,
      tenancyEnd,
      tenancyManager,
    } = this.props;

    return (
      <div className={classes.root}>
        <Grid container spacing={16}>
          <Grid item xs={12}>
            <Hidden lgUp>
              <div className={classes.iconFieldWrapper}>
                <PersonOutlinedIcon className={`${classes.icon} ItemIcon`} />
                <div>
                  <Typography className={classes.label}>
                    {getString(stringsComponent, 'NAME_LABEL')}
                  </Typography>
                  <ContentRow customClass={classes.contentRow}>
                    <Typography className={classes.value}>{name}</Typography>
                  </ContentRow>
                </div>
              </div>
              <div className={classes.iconFieldWrapper}>
                <AssignmentOutlinedIcon
                  className={`${classes.icon} ItemIcon`}
                />
                <div>
                  <Typography className={classes.label}>
                    {getString(stringsComponent, 'REFERENCE_LABEL')}
                  </Typography>
                  <ContentRow customClass={classes.contentRow}>
                    <Typography className={classes.value}>
                      {reference}
                    </Typography>
                  </ContentRow>
                </div>
              </div>
              <div className={classes.iconFieldWrapper}>
                <LocationOnOutlinedIcon
                  className={`${classes.icon} ItemIcon`}
                />
                <div>
                  <Typography className={classes.label}>
                    {getString(stringsComponent, 'ADDRESS_LABEL')}
                  </Typography>
                  <ContentRow customClass={classes.contentRow}>
                    <Typography className={classes.value}>{address}</Typography>
                  </ContentRow>
                </div>
              </div>
              <div className={classes.iconFieldWrapper}>
                <HomeOutlinedIcon className={`${classes.icon} ItemIcon`} />
                <div>
                  <Typography className={classes.label}>
                    {getString(stringsComponent, 'TENANCY_STATUS_LABEL')}
                  </Typography>
                  <ContentRow customClass={classes.contentRow}>
                    <Typography className={classes.value}>
                      {tenancyStatus}
                    </Typography>
                  </ContentRow>
                </div>
              </div>
              <div className={classes.iconFieldWrapper}>
                <DateRangeOutlinedIcon className={`${classes.icon} ItemIcon`} />
                <div>
                  <Typography className={classes.label}>
                    {tenancyEnd
                      ? getString(stringsComponent, 'TENANCY_START_END_LABEL')
                      : getString(stringsComponent, 'TENANCY_START_LABEL')}
                  </Typography>
                  <ContentRow customClass={classes.contentRow}>
                    <Typography className={classes.value}>
                      {tenancyEnd
                        ? `${stringToDateShortLeadingZero(
                            tenancyStart
                          )} - ${stringToDateShortLeadingZero(tenancyEnd)}`
                        : stringToDateShortLeadingZero(tenancyStart)}
                    </Typography>
                  </ContentRow>
                </div>
              </div>
              <div className={classes.iconFieldWrapper}>
                <PortraitOutlinedIcon className={`${classes.icon} ItemIcon`} />
                <div>
                  <Typography className={classes.label}>
                    {getString(stringsComponent, 'TENANCY_MANAGER_LABEL')}
                  </Typography>
                  <ContentRow customClass={classes.contentRow}>
                    <Typography className={classes.value}>
                      {tenancyManager}
                    </Typography>
                  </ContentRow>
                </div>
              </div>
            </Hidden>
            <Hidden mdDown>
              <div className={classes.line}>
                <div className={classes.iconFieldWrapper}>
                  <PersonOutlinedIcon className={`${classes.icon} ItemIcon`} />
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'NAME_LABEL')}
                    </Typography>
                    <ContentRow customClass={classes.contentRow}>
                      <Typography className={classes.value}>{name}</Typography>
                    </ContentRow>
                  </div>
                </div>
                <div className={classes.iconFieldWrapper}>
                  <AssignmentOutlinedIcon
                    className={`${classes.icon} ItemIcon`}
                  />
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'REFERENCE_LABEL')}
                    </Typography>
                    <ContentRow customClass={classes.contentRow}>
                      <Typography className={classes.value}>
                        {reference}
                      </Typography>
                    </ContentRow>
                  </div>
                </div>
              </div>
              <div className={classes.line}>
                <div className={classes.iconFieldWrapper}>
                  <LocationOnOutlinedIcon
                    className={`${classes.icon} ItemIcon`}
                  />
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'ADDRESS_LABEL')}
                    </Typography>
                    <ContentRow customClass={classes.contentRow}>
                      <Typography className={classes.value}>
                        {address}
                      </Typography>
                    </ContentRow>
                  </div>
                </div>
                <div className={classes.iconFieldWrapper}>
                  <HomeOutlinedIcon className={`${classes.icon} ItemIcon`} />
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'TENANCY_STATUS_LABEL')}
                    </Typography>
                    <ContentRow customClass={classes.contentRow}>
                      <Typography className={classes.value}>
                        {tenancyStatus}
                      </Typography>
                    </ContentRow>
                  </div>
                </div>
              </div>
              <div className={classes.line}>
                <div className={classes.iconFieldWrapper}>
                  <DateRangeOutlinedIcon
                    className={`${classes.icon} ItemIcon`}
                  />
                  <div>
                    <Typography className={classes.label}>
                      {tenancyEnd
                        ? getString(stringsComponent, 'TENANCY_START_END_LABEL')
                        : getString(stringsComponent, 'TENANCY_START_LABEL')}
                    </Typography>
                    <ContentRow customClass={classes.contentRow}>
                      <Typography className={classes.value}>
                        {tenancyEnd
                          ? `${stringToDateShortLeadingZero(
                              tenancyStart
                            )} - ${stringToDateShortLeadingZero(tenancyEnd)}`
                          : stringToDateShortLeadingZero(tenancyStart)}
                      </Typography>
                    </ContentRow>
                  </div>
                </div>
                <div className={classes.iconFieldWrapper}>
                  <PortraitOutlinedIcon
                    className={`${classes.icon} ItemIcon`}
                  />
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'TENANCY_MANAGER_LABEL')}
                    </Typography>
                    <ContentRow customClass={classes.contentRow}>
                      <Typography className={classes.value}>
                        {tenancyManager}
                      </Typography>
                    </ContentRow>
                  </div>
                </div>
              </div>
            </Hidden>
          </Grid>
        </Grid>
      </div>
    );
  }
}

TenancyInformationCard.propTypes = {};

TenancyInformationCard.defaultProps = {};

export default withStyles(styles, { withTheme: true })(TenancyInformationCard);
